import { Subscription, from } from 'rxjs';
// Angular
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
// Layout
import { LayoutConfigService, SplashScreenService, TranslationService } from './core/_base/layout';
// language list
import { locale as enLang } from './core/_config/i18n/en';
import { locale as chLang } from './core/_config/i18n/ch';
import { locale as esLang } from './core/_config/i18n/es';
import { locale as jpLang } from './core/_config/i18n/jp';
import { locale as deLang } from './core/_config/i18n/de';
import { locale as frLang } from './core/_config/i18n/fr';
import { locale as vnLang } from './core/_config/i18n/vn';

import { NgxSpinnerService } from 'ngx-spinner';
import { RootSpinnerService } from '@app/services/root-spinner.service';

import { SystemSettingStore } from './services/change-setting.service';
import { SystemSettingService } from './api/systemsettting.service';

import { environment } from 'environments/environment';
// MetaInjectionService import removed

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'body[kt-root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
  // Public properties
  title = 'Metronic';
  buttonCollection = [];
  loader: boolean;
  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

  /**
   * Component constructor
   *
   * @param translationService: TranslationService
   * @param router: Router
   * @param layoutConfigService: LayoutCongifService
   * @param splashScreenService: SplashScreenService
   */
  constructor(
    private translationService: TranslationService,
    private router: Router,
    private layoutConfigService: LayoutConfigService,
    private splashScreenService: SplashScreenService,
    private spinner: NgxSpinnerService,
    public rootSpinner: RootSpinnerService,
    private storeSystem: SystemSettingStore, // Temporarily disabled for debugging // private metaInjectionService: MetaInjectionService
    private system: SystemSettingService
  ) {
    this.unsubscribe.push(
      RootSpinnerService.statusChanged.subscribe((item) => this.spinnerStatusChanged(item))
    );

    // register translations
    this.translationService.loadTranslations(
      enLang,
      chLang,
      esLang,
      jpLang,
      deLang,
      frLang,
      vnLang
    );
  }

  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */

  spinnerStatusChanged(item: boolean) {
    if (item) {
      this.spinner.show();
    } else {
      this.spinner.hide();
    }
  }

  /**
   * On init
   */

  // embedFChatScript() {
  //   const scriptEl = document.createElement('script');
  //   scriptEl.type = 'text/javascript';
  //   scriptEl.src = 'https://cdn.fchat.co/assets/embed/webchat.js?id=64992d8249633f705f15528d';
  //   scriptEl.async = true;
  //   document.getElementsByTagName('head')[0].appendChild(scriptEl);
  // }

  ngOnInit(): void {
    // this.embedFChatScript();

    // enable/disable loader
    this.loader = this.layoutConfigService.getConfig('loader.enabled');

    const routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // hide splash screen
        this.splashScreenService.hide();

        // scroll to top on every route change
        window.scrollTo(0, 0);

        // to display back the body content
        setTimeout(() => {
          document.body.classList.add('kt-page--loaded');
        }, 500);

        // Set homepage meta if on homepage
        if (event.url === '/' || event.url === '') {
          // Temporarily disabled for debugging
          // this.metaInjectionService.setHomepageMeta();
        }
      }
    });
    this.unsubscribe.push(routerSubscription);

    //language
    const savedLang = localStorage.getItem('language');

    //  Nếu có thì set lại
    if (savedLang) {
      this.translationService.setLanguage(savedLang);
    } else {
      this.translationService.setLanguage('vi');
    }

    // Set initial homepage meta - temporarily disabled for debugging
    // this.metaInjectionService.setHomepageMeta();
    this.getIcon();
    this.loadIcon();
  }

  getIcon() {

    this.system.apiSystemSettingGet('type==FAVICON').subscribe((res) => {
      if (res.success && res.data.collection && res.data.collection.length > 0) {
        const children = res.data.collection[0].children;

        if (children && children.length > 0) {
          const ref = children.find(
            (item) => item.value && item.value !== '' && item.is_hidden === false
          );
       
          if (ref) {
            this.setFavicon(environment.backendhost + ref.value);
          }
        }
      }
    });
  }
  loadIcon() {
    this.storeSystem.settings$.subscribe((res) => {
      const ref = res.favicons.find(
        (item) => item.is_hidden == false && item.url !== '' && item.url !== null
      );
      if (ref) {
        this.setFavicon(ref.url);
      }
    });
  }
  setFavicon(url: string): void {
    const faviconUrl = url.includes('?') ? `${url}&v=${Date.now()}` : `${url}?v=${Date.now()}`;

    let link: HTMLLinkElement =
      document.querySelector("link[rel~='icon']") || document.createElement('link');

    link.rel = 'icon';
    link.type = 'image/x-icon';
    link.href = faviconUrl;

    document.head.appendChild(link);
  }

  /**
   * On Destroy
   */
  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
